import React from 'react'
import PropTypes from 'prop-types'
import PerformanceRatingOrgDetailReport from './PerformanceRatingOrgDetailReport'
import { range, find, get } from 'lodash'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'

export default function PerformanceRatingOrgDetail(props) {

	const groups = ['E', 'M', 'P', 'S']

	const groupsNames = {
		'E': 'Executive (E)',
		'M': 'People Mgmt (M)',
		'P': 'Professional IC (P)',
		'S': 'Support (S)',
	}

	const onApply = (filters) => {
		props.onApply(filters, 'PerformanceRatingOrgDetail')
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { total_row: 0, totalN: 0, total_average_rating: 0, totalPercent: 0 },
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', percent: '', averageRating: '' },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			if (dataInReport) {
				groupData[groupKey].current.n = get(dataInReport, 'total', 0)
				groupData[groupKey].current.percent = get(dataInReport, 'total', 0)
				groupData[groupKey].current.averageRating = round(get(dataInReport, 'avg_performance_rating', ''))
				groupSummary[groupKey].current.totalN = round(groupSummary[groupKey].current.totalN + groupData[groupKey].current.n)
				groupSummary[groupKey].current.total_average_rating += groupData[groupKey].current.averageRating
				if (groupData[groupKey].current.averageRating !== 0) {
					groupSummary[groupKey].current.total_row += 1
				}
			}
		})
		levelsData.push(groupData)
	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = round((level[group].current.n / groupSummary[group].current.totalN) * 100)
				groupSummary[group].current.totalPercent = round(groupSummary[group].current.totalPercent + level[group].current.percent)
			}
		})
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN = round(currentTotalN + groupSummary[key].current.totalN)
		groupSummary[key].current.total_average_rating = round(groupSummary[key].current.total_average_rating / groupSummary[key].current.total_row).toFixed(1)
		groupSummary[key].current.totalPercent = round(groupSummary[key].current.totalPercent, 0)
	})

	/**
	 * Below is the Display logic for Rows
	 */
	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.averageRating = level[group].current.averageRating.toFixed(1)
			}
		})
	})

	return (
		<React.Fragment>
			<DataFilters
				fetchedFilterData={props.fetchedFilterData}
				filtersData={props.filtersData}
				onDataFilterSelect={props.onDataFilterSelect}
				componentName={'PerformanceRatingOrgDetail'}
				reportFilters={props.reportFilters}
				onApply={onApply}
				resetFilter={props.resetFilter}
				reportFiltersType={props.reportFiltersType}
				reportDataChanged={props.reportDataChanged}
			/>
			<PerformanceRatingOrgDetailReport currentTotalN={currentTotalN} groups={groups} groupSummary={groupSummary} groupsNames={groupsNames} levelsData={levelsData}></PerformanceRatingOrgDetailReport>
		</React.Fragment>
	)
}

PerformanceRatingOrgDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
}
